import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _methods;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "./ContractPay.css";
import "./ContractPay2.css";
import c from "vue";
import o from "../../node_modules/.pnpm/@mx_fsp-mweb-env@0.125.0/node_modules/@mx/fsp-mweb-env/dist/index.esm.js";
import { openPage as g } from "../../node_modules/.pnpm/@mx_fsp-mweb-bridge@0.125.0/node_modules/@mx/fsp-mweb-bridge/dist/index.esm.js";
import { AddWalletSdk as f } from "../../node_modules/.pnpm/@mx_fsp-mweb-ecny-sdk@0.125.0/node_modules/@mx/fsp-mweb-ecny-sdk/dist/index.esm.js";
import "../../node_modules/.pnpm/core-js@3.37.1/node_modules/core-js/modules/es.regexp.exec.js";
import "../../node_modules/.pnpm/core-js@3.37.1/node_modules/core-js/modules/es.string.split.js";
import "../../node_modules/.pnpm/core-js@3.37.1/node_modules/core-js/modules/es.array.concat.js";
import "../../node_modules/.pnpm/core-js@3.37.1/node_modules/core-js/modules/es.string.replace.js";
import "../../node_modules/.pnpm/core-js@3.37.1/node_modules/core-js/modules/es.regexp.constructor.js";
import "../../node_modules/.pnpm/core-js@3.37.1/node_modules/core-js/modules/es.regexp.to-string.js";
import "../../node_modules/.pnpm/core-js@3.37.1/node_modules/core-js/modules/es.object.keys.js";
import "../../node_modules/.pnpm/core-js@3.37.1/node_modules/core-js/modules/es.array.map.js";
import "../../node_modules/.pnpm/core-js@3.37.1/node_modules/core-js/modules/es.number.constructor.js";
import "../../node_modules/.pnpm/core-js@3.37.1/node_modules/core-js/modules/es.array.index-of.js";
import "../../node_modules/.pnpm/core-js@3.37.1/node_modules/core-js/modules/es.string.search.js";
import "../../node_modules/.pnpm/core-js@3.37.1/node_modules/core-js/modules/es.array.slice.js";
import "../../node_modules/.pnpm/core-js@3.37.1/node_modules/core-js/modules/es.object.to-string.js";
import "../../node_modules/.pnpm/core-js@3.37.1/node_modules/core-js/modules/web.dom-collections.for-each.js";
import "../../node_modules/.pnpm/core-js@3.37.1/node_modules/core-js/modules/es.string.match.js";
import "../../node_modules/.pnpm/core-js@3.37.1/node_modules/core-js/modules/es.parse-int.js";
import "../../node_modules/.pnpm/core-js@3.37.1/node_modules/core-js/modules/es.parse-float.js";
import "../../node_modules/.pnpm/core-js@3.37.1/node_modules/core-js/modules/es.string.trim.js";
import { bankConfig as v } from "../../config/bankInfo.js";
import "../../node_modules/.pnpm/vant@2.13.2_vue@2.7.16/node_modules/vant/es/index.js";
import { signRouting as _, sendMessage as b, contractPaySign as C } from "../../services/index.js";
import { lx as e } from "../../utils/analytics.js";
/* empty css                 */
/* empty css                 */
import k from "../../_virtual/_plugin-vue2_normalizer.js";
import S from "../../node_modules/.pnpm/vant@2.13.2_vue@2.7.16/node_modules/vant/es/popup/index.js";
import n from "../../node_modules/.pnpm/vant@2.13.2_vue@2.7.16/node_modules/vant/es/toast/index.js";
import w from "../../node_modules/.pnpm/vant@2.13.2_vue@2.7.16/node_modules/vant/es/dialog/index.js";
c.use(S);
c.use(n);
c.use(w);
var r = 60,
  y = 6,
  l = 400175,
  d = 400176,
  m = 400177,
  h = 400181,
  T = 210032,
  E = {
    name: "ContractPay",
    props: {
      fspActivityId: {
        // 数币活动ID
        type: String,
        default: ""
      },
      cid: {
        type: String,
        default: ""
      },
      promoInfo: {
        // 营销ID
        type: String,
        default: ""
      },
      orderNo: {
        // 交易订单号
        type: String,
        default: ""
      },
      signTypeAlias: {
        // 指定签约方式
        type: String,
        default: ""
      },
      currentEnv: {
        // 当前系统
        type: String,
        default: ""
      },
      invokeType: {
        // 调用场景
        type: String,
        default: ""
      },
      utmSource: {
        type: String,
        default: ""
      }
    },
    data: function data() {
      return {
        bankId: 10001,
        // 银行编号
        show: !1,
        visible: !1,
        showModal: !1,
        mobileMask: "",
        sendStatus: !1,
        serialNumber: "",
        // 短信序列号
        bankName: "",
        errorMessage: "",
        smsCode: "",
        smsTip: "",
        canClickSms: !1,
        isShowErrorMsg: !1,
        isShowNoSmsCodeModal: !1,
        isSmsCodeOverMaxLength: !1,
        remainTime: r,
        bankConfig: v,
        clock: null,
        inputCursor: !1,
        isShowDialog: !1,
        addWalletSdk: null,
        signType: "",
        unavailableReason: ""
        // 不可签约的原因
      };
    },
    computed: {
      tracking: function tracking() {
        return {
          utm_source: this.utmSource || -999,
          from: o.from || -999,
          fsp_activity_id: this.fspActivityId || -999,
          bank_id: this.bankId || -999,
          activity_id: window.Block ? window.Block.ID : -999,
          scene_type: this.orderNo ? 1 : 0,
          // 场景类型： 1-支付场景，0-非支付场景
          trade_no: this.orderNo || -999,
          // 订单交易号，仅支付场景支持
          invoke_type: this.invokeType || -999
          // 调用场景类型 调用方自传
        };
      },
      userToken: function userToken() {
        return this.currentEnv === "isInBoc" && o.commonParams.token || "";
      }
    },
    watch: {
      smsCode: function smsCode(t) {
        if (this.isSmsCodeOverMaxLength) {
          this.isSmsCodeOverMaxLength = !1;
          return;
        }
        if (t.length > y) {
          this.smsCode = t.substring(0, 6), this.isSmsCodeOverMaxLength = !0;
          return;
        }
      },
      visible: {
        handler: function handler(t) {
          var _this = this;
          t ? (this.show = t, this.remainTime === r && this.sendSms(), this.$nextTick(function () {
            _this.$refs.input && (_this.$refs.input.addEventListener("focus", _this.focusEventHandler, !1), _this.$refs.input.addEventListener("blur", _this.blurEventHandler, !1));
          }), e.mv("b_cube_ot9tq2j3_mv", this.tracking, {
            cid: this.cid
          })) : (this.show = t, this.isShowDialog = t, this.isShowErrorMsg = t, this.smsCode = "", this.$refs.input && (this.$refs.input.removeEventListener("focus", this.focusEventHandler, !1), this.$refs.input.removeEventListener("blur", this.blurEventHandler, !1)));
        },
        immediate: !0
      },
      isShowErrorMsg: function isShowErrorMsg(t) {
        t && e.mv("b_cube_x1sruw8x_mv", _objectSpread(_objectSpread({}, this.tracking), {}, {
          error_info: this.errorMessage || -999
        }), {
          cid: this.cid
        });
      }
    },
    mounted: function mounted() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.addWalletSdk = new f({
                handleAddWalletFailCallback: function handleAddWalletFailCallback() {},
                handleAddWalletSuccessCallback: function handleAddWalletSuccessCallback() {}
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    methods: (_methods = {
      //  签约路由接口 判断签约方式
      signRouting: function signRouting(t, s) {
        var _this3 = this;
        return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var i;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _this3.bankId = t;
                _context2.prev = 1;
                _context2.next = 4;
                return _({
                  insId: t,
                  signType: s || ""
                  //指定签约方式：CONTRACT_SIGN、PULL_SIGN
                });
              case 4:
                i = _context2.sent;
                if (i) {
                  _context2.next = 7;
                  break;
                }
                return _context2.abrupt("return");
              case 7:
                _this3.signType = i.signType, i.unavailableReason && (_this3.unavailableReason = i.unavailableReason), _this3.handleSignType();
                _context2.next = 13;
                break;
              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](1);
                _this3.signType = "PULL_SIGN", _this3.unavailableReason = "DOWNGRAD", _this3.handleSignType();
              case 13:
              case "end":
                return _context2.stop();
            }
          }, _callee2, null, [[1, 10]]);
        }))();
      },
      // 签约方式判断
      handleSignType: function handleSignType() {
        switch (this.signType) {
          case "CONTRACT_SIGN":
            this.visible = !0, this.emitSignType(!1);
            break;
          case "NONE":
            this.handleNoneSignType();
            break;
          default:
            this.handlePullSignType();
        }
      },
      // 验证短信
      sendSms: function sendSms() {
        var _this4 = this;
        return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          var t, s;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _this4.setClock();
                _context3.next = 4;
                return b({
                  institutionId: _this4.bankId,
                  token: _this4.userToken
                });
              case 4:
                t = _context3.sent;
                _this4.mobileMask = t && t.mobileMask || "", _this4.sendStatus = t && t.sendStatus, _this4.serialNumber = t && t.serialNumber ? t.serialNumber : _this4.serialNumber, _this4.bankName = t && t.bankName || "", _this4.errorMessage = t && t.errorMessage || "";
                s = t && t.errorCode || 0;
                if (_this4.sendStatus) {
                  _context3.next = 19;
                  break;
                }
                if (!(e.mv("b_cube_x1sruw8x_mv", _objectSpread(_objectSpread({}, _this4.tracking), {}, {
                  error_info: _this4.errorMessage || -999
                }), {
                  cid: _this4.cid
                }), s === l || s === h)) {
                  _context3.next = 14;
                  break;
                }
                if (!_this4.orderNo) {
                  _context3.next = 12;
                  break;
                }
                e.mv("b_cube_6919f7c3_mv", _this4.tracking, {
                  cid: _this4.cid
                }), _this4.$dialog.confirm({
                  title: "绑定失败",
                  message: "绑定钱包失败，请选择其他支付方式。",
                  confirmButtonText: "知道了",
                  showCancelButton: !1,
                  messageAlign: "center",
                  lockScroll: !0,
                  getContainer: ".contract"
                }).then(function () {
                  e.mc("b_cube_6919f7c3_mc", _objectSpread(_objectSpread({}, _this4.tracking), {}, {
                    button_name: "知道了"
                  }), {
                    cid: _this4.cid
                  }), _this4.$emit("signFail"), _this4.onClose();
                }).catch(function () {
                  _this4.$emit("signFail"), _this4.onClose();
                });
                return _context3.abrupt("return");
              case 12:
                _this4.handleShowBindWalletPopup();
                return _context3.abrupt("return");
              case 14:
                if (!(s === m || s === d)) {
                  _context3.next = 17;
                  break;
                }
                n({
                  message: _this4.errorMessage || "系统异常",
                  icon: "https://p0.meituan.net/wxapp/944447a29f787f6a550364ed7db9a6ce1397.png",
                  getContainer: ".contract"
                });
                return _context3.abrupt("return");
              case 17:
                _this4.isShowErrorMsg = !!_this4.errorMessage;
                return _context3.abrupt("return");
              case 19:
                n({
                  message: "短信已发送",
                  getContainer: ".contract"
                });
                _context3.next = 28;
                break;
              case 22:
                _context3.prev = 22;
                _context3.t0 = _context3["catch"](0);
                if (!(e.mv("b_cube_7mh3zm83_mv", _objectSpread(_objectSpread({}, _this4.tracking), {}, {
                  error_info: _context3.t0 && _context3.t0.message || -999
                }), {
                  cid: _this4.cid
                }), window.Owl && window.Owl.addError({
                  name: "【协议支付-短信发送接口异常】",
                  msg: JSON.stringify(_context3.t0)
                }, {
                  level: "error"
                }), Number(_context3.t0.code) === T)) {
                  _context3.next = 27;
                  break;
                }
                _this4.sendStatus = !0;
                return _context3.abrupt("return");
              case 27:
                n({
                  message: _context3.t0 && _context3.t0.message || "系统异常",
                  icon: "https://p0.meituan.net/wxapp/944447a29f787f6a550364ed7db9a6ce1397.png"
                });
              case 28:
              case "end":
                return _context3.stop();
            }
          }, _callee3, null, [[0, 22]]);
        }))();
      },
      onHandleConfirmSmsCode: function onHandleConfirmSmsCode() {
        var _this5 = this;
        return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
          var t, s, i, a, p, u;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                if (!_this5.smsCode || _this5.smsCode.length < 6) {
                  _context4.next = 38;
                  break;
                }
                if (!(e.mc("b_cube_l59fah1k_mc", _this5.tracking, {
                  cid: _this5.cid
                }), !_this5.sendStatus)) {
                  _context4.next = 4;
                  break;
                }
                n({
                  message: "验证码错误",
                  icon: "https://p0.meituan.net/wxapp/944447a29f787f6a550364ed7db9a6ce1397.png",
                  getContainer: ".contract"
                }), e.mv("b_cube_7mh3zm83_mv", _objectSpread(_objectSpread({}, _this5.tracking), {}, {
                  error_info: "验证码错误"
                }), {
                  cid: _this5.cid
                });
                return _context4.abrupt("return");
              case 4:
                if (_this5.serialNumber) {
                  _context4.next = 7;
                  break;
                }
                n({
                  message: "验证码已失效，请重新获取",
                  icon: "https://p0.meituan.net/wxapp/944447a29f787f6a550364ed7db9a6ce1397.png"
                }), e.mv("b_cube_7mh3zm83_mv", _objectSpread(_objectSpread({}, _this5.tracking), {}, {
                  error_info: "流水号缺失"
                }), {
                  cid: _this5.cid
                });
                return _context4.abrupt("return");
              case 7:
                _context4.prev = 7;
                _context4.next = 10;
                return C({
                  institutionId: _this5.bankId,
                  verifyCode: _this5.smsCode,
                  serialNumber: _this5.serialNumber,
                  promoInfo: _this5.promoInfo,
                  orderNo: _this5.orderNo,
                  token: _this5.userToken
                });
              case 10:
                t = _context4.sent;
                s = t && t.signResult;
                i = t && t.errorMessage || "";
                a = t && t.errorCode || 0;
                p = t && t.tokenId || "";
                u = t && t.ecnyPayProductCode || "";
                if (!s) {
                  _context4.next = 20;
                  break;
                }
                n({
                  message: "绑定成功",
                  getContainer: ".contract"
                }), e.mv("b_cube_0rocesuh_mv", _this5.tracking, {
                  cid: _this5.cid
                }), _this5.onClose(), _this5.$emit("afterContract", {
                  tokenId: p,
                  ecnyPayProductCode: u
                });
                _context4.next = 30;
                break;
              case 20:
                if (!(e.mv("b_cube_x1sruw8x_mv", _objectSpread(_objectSpread({}, _this5.tracking), {}, {
                  error_info: _this5.errorMessage || -999
                }), {
                  cid: _this5.cid
                }), a === l || a === h)) {
                  _context4.next = 26;
                  break;
                }
                if (!_this5.orderNo) {
                  _context4.next = 24;
                  break;
                }
                e.mv("b_cube_6919f7c3_mv", _this5.tracking, {
                  cid: _this5.cid
                }), _this5.$dialog.confirm({
                  title: "绑定失败",
                  message: "绑定钱包失败，请选择其他支付方式。",
                  confirmButtonText: "知道了",
                  showCancelButton: !1,
                  messageAlign: "center",
                  lockScroll: !0,
                  getContainer: ".contract"
                }).then(function () {
                  e.mc("b_cube_6919f7c3_mc", _objectSpread(_objectSpread({}, _this5.tracking), {}, {
                    button_name: "知道了"
                  }), {
                    cid: _this5.cid
                  }), _this5.$emit("signFail"), _this5.onClose();
                }).catch(function () {
                  _this5.$emit("signFail"), _this5.onClose();
                });
                return _context4.abrupt("return");
              case 24:
                _this5.handleShowBindWalletPopup();
                return _context4.abrupt("return");
              case 26:
                if (!(a === m || a === d)) {
                  _context4.next = 29;
                  break;
                }
                n({
                  message: i || "系统异常",
                  icon: "https://p0.meituan.net/wxapp/944447a29f787f6a550364ed7db9a6ce1397.png",
                  getContainer: ".contract"
                });
                return _context4.abrupt("return");
              case 29:
                _this5.errorMessage = i, _this5.isShowErrorMsg = !!_this5.errorMessage;
              case 30:
                _context4.next = 38;
                break;
              case 32:
                _context4.prev = 32;
                _context4.t0 = _context4["catch"](7);
                if (!(e.mv("b_cube_7mh3zm83_mv", _objectSpread(_objectSpread({}, _this5.tracking), {}, {
                  error_info: _context4.t0 && _context4.t0.message || -999
                }), {
                  cid: _this5.cid
                }), n({
                  message: _context4.t0 && _context4.t0.message || "系统异常",
                  icon: "https://p0.meituan.net/wxapp/944447a29f787f6a550364ed7db9a6ce1397.png",
                  getContainer: ".contract"
                }), _context4.t0.code === "999999")) {
                  _context4.next = 37;
                  break;
                }
                window.Owl && window.Owl.addError({
                  name: "【协议支付-用户登录异常】",
                  msg: document.cookie
                }, {
                  level: "error"
                });
                return _context4.abrupt("return");
              case 37:
                window.Owl && window.Owl.addError({
                  name: "【协议支付-签约接口异常】",
                  msg: JSON.stringify(_context4.t0)
                }, {
                  level: "error"
                });
              case 38:
              case "end":
                return _context4.stop();
            }
          }, _callee4, null, [[7, 32]]);
        }))();
      },
      smsCodeCancel: function smsCodeCancel() {
        this.smsCode && (this.smsCode = "", this.isShowErrorMsg = !1);
      },
      setClock: function setClock() {
        var _this6 = this;
        this.remainTime = r, this.canClickSms = !1, this.isShowErrorMsg = !1, this.smsCode = "", this.smsTip = "", this.clock = window.setInterval(function () {
          _this6.remainTime--, _this6.remainTime < 1 && (window.clearInterval(_this6.clock), _this6.smsTip = "重新发送", _this6.remainTime = r, _this6.canClickSms = !0);
        }, 1e3);
      },
      onHandleSendSms: function onHandleSendSms() {
        this.canClickSms && (e.mc("b_cube_2u8u3qp0_mc", this.tracking, {
          cid: this.cid
        }), this.sendSms());
      }
    }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_methods, "smsCodeCancel", function smsCodeCancel() {
      this.smsCode && (this.smsCode = "", this.isShowErrorMsg = !1);
    }), "openProtocal", function openProtocal() {
      g(this.bankConfig[this.bankId].protocolLink);
    }), "closeDialog", function closeDialog() {
      this.$dialog.close(), this.isShowDialog = !1;
    }), "handleNoneSignType", function handleNoneSignType() {
      if (this.unavailableReason === "limitForMessage") this.handleShowBindWalletPopup();else if (this.unavailableReason === "walletNotOpen") this.currentEnv !== "isInBoc" ? (this.addWalletSdk.jumpToDcepApp(), this.emitSignType(!1)) : this.emitSignType(!0);else if (this.currentEnv !== "isInBoc") {
        this.addWalletSdk.addWallet(this.bankConfig[this.bankId].payType, !o.isInWaimai), this.emitSignType(!1);
        return;
      } else this.emitSignType(!0);
    }), "handlePullSignType", function handlePullSignType() {
      if (this.currentEnv !== "isInBoc") {
        this.addWalletSdk.addWallet(this.bankConfig[this.bankId].payType, !o.isInWaimai), this.emitSignType(!1);
        return;
      } else this.emitSignType(!0);
    }), "handleShowBindWalletPopup", function handleShowBindWalletPopup() {
      var _this7 = this;
      e.mv("b_cube_6919f7c3_mv", this.tracking, {
        cid: this.cid
      }), this.isShowDialog = !0, this.$dialog.confirm({
        title: " ",
        message: "前往数字人民币App继续绑定",
        confirmButtonText: "去数币App绑定",
        cancelButtonText: "暂不绑定",
        messageAlign: "center",
        lockScroll: !0,
        getContainer: ".contract"
      }).then(function () {
        _this7.show = !1, _this7.isShowDialog = !1, _this7.$dialog.close(), _this7.currentEnv === "isInBoc" ? _this7.emitSignType(!0) : _this7.addWalletSdk.addWallet(_this7.bankConfig[_this7.bankId].payType, !o.isInWaimai), e.mc("b_cube_6919f7c3_mc", _objectSpread(_objectSpread({}, _this7.tracking), {}, {
          button_name: "去数币App绑定"
        }), {
          cid: _this7.cid
        });
      }).catch(function () {
        _this7.isShowDialog = !1, e.mc("b_cube_6919f7c3_mc", _objectSpread(_objectSpread({}, _this7.tracking), {}, {
          button_name: "暂不绑定"
        }), {
          cid: _this7.cid
        });
      });
    }), "emitSignType", function emitSignType(t) {
      this.$emit("contractMethod", t, this.signType, this.unavailableReason);
    }), "onClose", function onClose() {
      this.show = !1, this.visible = !1;
    }), "openModal", function openModal() {
      e.mc("b_cube_33n1bvcz_mc", this.tracking, {
        cid: this.cid
      }), this.showModal = !0, e.mv("b_cube_61u0utsn_mv", this.tracking, {
        cid: this.cid
      });
    }), "closeModal", function closeModal() {
      this.showModal = !1, e.mc("b_cube_61u0utsn_mc", this.tracking, {
        cid: this.cid
      });
    }), _defineProperty(_defineProperty(_defineProperty(_methods, "handleFocus", function handleFocus() {
      this.$refs.input.focus();
    }), "focusEventHandler", function focusEventHandler() {
      this.inputCursor = !0, e.mc("b_cube_piwki7pp_mc", this.tracking, {
        cid: this.cid
      });
    }), "blurEventHandler", function blurEventHandler() {
      this.inputCursor = !1;
    }))
  };
var M = function M() {
    var s = this,
      i = s._self._c;
    return i("div", {
      staticClass: "contract"
    }, [s.isShowDialog ? i("img", {
      staticClass: "close",
      attrs: {
        src: "https://p1.meituan.net/wxapp/dcb64b05bc66ca120539630d1a702c47337.png",
        alt: ""
      },
      on: {
        click: s.closeDialog
      }
    }) : s._e(), i("van-popup", {
      staticClass: "contract-pay",
      style: {
        height: "85%"
      },
      attrs: {
        position: "bottom",
        "close-on-click-overlay": !1
      },
      on: {
        close: s.onClose
      },
      model: {
        value: s.show,
        callback: function callback(a) {
          s.show = a;
        },
        expression: "show"
      }
    }, [i("input", {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: s.smsCode,
        expression: "smsCode"
      }],
      ref: "input",
      staticClass: "contract-pay-input",
      attrs: {
        id: "contract-pay-input",
        type: "tel",
        maxlength: "6",
        autofocus: ""
      },
      domProps: {
        value: s.smsCode
      },
      on: {
        input: function input(a) {
          a.target.composing || (s.smsCode = a.target.value);
        }
      }
    }), i("div", {
      staticClass: "contract-pay-close",
      on: {
        click: s.onClose
      }
    }), i("div", {
      staticClass: "contract-pay-title"
    }, [s._v("绑定数字人民币钱包")]), i("div", {
      staticClass: "contract-pay-bank"
    }, [i("img", {
      attrs: {
        src: s.bankConfig[s.bankId] && s.bankConfig[s.bankId].logo
      }
    }), i("div", [s._v(s._s(s.bankConfig[s.bankId] && s.bankConfig[s.bankId].name))])]), i("div", {
      staticClass: "contract-pay-message"
    }, [s._v(" 验证码已发送至" + s._s(s.mobileMask) + " "), i("span", {
      on: {
        click: s.openModal
      }
    }, [s._v("收不到验证码？")])]), i("div", {
      staticClass: "cp-sms-wrapper"
    }, [i("div", {
      class: ["cp-sms", {
        "cp-sms-border": s.isShowErrorMsg
      }]
    }, [i("div", {
      staticClass: "cp-sms-input-wrapper"
    }, [i("div", {
      staticClass: "cp-sms-title"
    }, [s._v("验证码")]), i("div", {
      staticClass: "cp-sms-input",
      on: {
        click: s.handleFocus
      }
    }, [i("div", {
      staticClass: "cp-sms-input-code"
    }, [s._v(s._s(s.smsCode))]), i("div", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: s.inputCursor,
        expression: "inputCursor"
      }],
      staticClass: "cp-sms-input-cursor"
    }), i("div", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !s.smsCode,
        expression: "!smsCode"
      }],
      staticClass: "cp-sms-input-placeholder"
    }, [s._v("请输入验证码")])])]), i("div", {
      staticClass: "cp-sms-send-wrapper"
    }, [i("div", {
      staticClass: "cp-sms-cancel",
      on: {
        click: s.smsCodeCancel
      }
    }), i("div", {
      staticClass: "cp-sms-divide"
    }), s.smsTip ? i("div", {
      staticClass: "cp-sms-send",
      on: {
        click: s.onHandleSendSms
      }
    }, [s._v(s._s(s.smsTip))]) : i("div", {
      staticClass: "cp-sms-time"
    }, [s._v(s._s(s.remainTime))])])]), s.isShowErrorMsg ? i("div", {
      staticClass: "cp-sms-errormsg"
    }, [s._v(s._s(s.errorMessage))]) : s._e()]), i("div", {
      class: [{
        "contract-pay-btn-active": s.smsCode.length === 6
      }, "contract-pay-btn"],
      on: {
        click: s.onHandleConfirmSmsCode
      }
    }, [s._v(" 同意协议并绑定")]), i("div", {
      staticClass: "contract-pay-protocal"
    }, [s._v(" 点击即代表您遵守活动规则及"), i("span", {
      on: {
        click: s.openProtocal
      }
    }, [s._v("相关协议")])])]), i("van-popup", {
      staticClass: "contract-pay-modal",
      model: {
        value: s.showModal,
        callback: function callback(a) {
          s.showModal = a;
        },
        expression: "showModal"
      }
    }, [i("div", {
      staticClass: "contract-pay-modal-title"
    }, [s._v("收不到验证码")]), i("div", {
      staticClass: "contract-pay-modal-body"
    }, [i("div", [s._v("1.请检查短信是否被手机安全软件拦截。")]), i("div", [s._v("2.由于运营商网络问题，可能存在延迟，请耐心等待或重试。")]), i("div", [s._v("3.每个用户每天最多只能获取5次短信验证码。")]), i("div", [s._v("4.若手机号已停用，您可以更换手机号后，前往数字人民币专区参与更多优惠活动。")])]), i("div", {
      staticClass: "contract-pay-modal-btn",
      on: {
        click: s.closeModal
      }
    }, [s._v("我知道了")]), i("div", {
      staticClass: "contract-pay-modal-close",
      on: {
        click: s.closeModal
      }
    })])], 1);
  },
  I = [],
  N = /* @__PURE__ */k(E, M, I, !1, null, "9ea2de91");
var ds = N.exports;
export { ds as default };
